import React from 'react';

import { LoginForm } from '../../components/LoginForm/LoginForm';

const HomeScreen = () => {
  return (
    <div>
      <LoginForm />
    </div>
  );
};

export default HomeScreen;
